import { ITimestampResponse } from '@/types/common';

export enum TagType {
  ARTICLE = 'article',
  OFFER = 'offer',
}

export interface ITag extends ITimestampResponse {
  id: number;
  name: string;
}

export interface IGetListTagResponse extends ITag {}

export interface IGetDetailTagResponse extends ITag {}
